function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import './tabs.scss';
import { PropTypes } from 'prop-types';

class Tabs extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {});

    _defineProperty(this, "selectTab", id => {
      this.setState(state => _objectSpread({}, state, {
        selected: id
      }));
    });
  }

  render() {
    const data = this.props.data;
    const _this$state$selected = this.state.selected,
          selected = _this$state$selected === void 0 ? data[0].id : _this$state$selected;
    return React.createElement("div", {
      className: "tabs"
    }, React.createElement("section", null, data && data.length && data.map(el => React.createElement(React.Fragment, {
      key: el.id
    }, React.createElement("input", {
      id: el.id,
      type: "radio",
      checked: el.id === selected,
      onChange: () => {}
    }), React.createElement("label", {
      htmlFor: el.id,
      onClick: () => this.selectTab(el.id)
    }, el.title)))), React.createElement("div", {
      className: "tabsContent"
    }, data && data.length && data.map(el => el.id === selected ? el.child() : null)));
  }

}

Tabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    child: PropTypes.func.isRequired
  })).isRequired
};
export default Tabs;